import React from 'react'
import Header from './Header'
import Footer from './Footer'
import Course from './Course'

const Courses = () => {
  return (
    <>
      <Header />
      <Course />
      <Footer /> 
    </>
  )
}

export default Courses
